import type { TelemetryTypes } from "@app-types/enums";
import { useContext } from "react";
import { createStore, useStore } from "zustand";
import { InstallAndConnectContext } from "../contexts/InstallAndConnect";

// TODO: Should this move?
export interface InstallAndConnectFormFields {
  argoAgreement: boolean;
  namespace?: string;
  argoUrl?: string;
  accountToken?: string;
  telemetryTypes: TelemetryTypes[];
  siteHost?: string;
  apiKey?: string;
  connectionName?: string;
  mdaiVersion?: string;
  lastCompletedStep: number;
}

interface InstallAndConnectFormState extends InstallAndConnectFormFields {
  setFormField: (
    key: keyof InstallAndConnectFormFields,
    value: InstallAndConnectFormFields[keyof InstallAndConnectFormFields],
  ) => void;
  setPartialState: (newState: Partial<InstallAndConnectFormFields>) => void;
  resetForm: () => void;
}

export type InstallAndConnectStore = ReturnType<
  typeof createInstallAndConnectStore
>;

function createDefaultConnectForm(): InstallAndConnectFormFields {
  return {
    argoAgreement: false,
    namespace: "mdai",
    telemetryTypes: [],
    mdaiVersion: "0.10.0",
    lastCompletedStep: -1,
  };
}

export const createInstallAndConnectStore = (
  initProps?: Partial<InstallAndConnectFormFields>,
) => {
  const defaultForm = createDefaultConnectForm();

  return createStore<InstallAndConnectFormState>()((set) => ({
    ...defaultForm,
    ...initProps,
    setFormField: (key, value) => set((state) => ({ ...state, [key]: value })),
    setPartialState: (newState: Partial<InstallAndConnectFormState>) =>
      set((oldState) => ({ ...oldState, ...newState })),
    resetForm: () => set(() => createDefaultConnectForm()),
  }));
};

export function useInstallAndConnectStore<T>(
  selector: (state: InstallAndConnectFormState) => T,
): T {
  const store = useContext(InstallAndConnectContext);
  if (!store)
    throw new Error("Missing InstallAndConnectContext Provider in the tree");
  return useStore(store, selector);
}
